(function(){
  if(window.__astafisPremiumInit){return;}
  window.__astafisPremiumInit=true;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer=null;
  if('IntersectionObserver' in window && !reduce){
    observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var video=entry.target;
        if(entry.isIntersecting){
          var play=video.play();
          if(play&&typeof play.catch==='function'){play.catch(function(){});}
        }else{video.pause();}
      });
    },{rootMargin:'200px 0px',threshold:0.15});
  }
  function init(root){
    var scope=root||document;
    scope.querySelectorAll('video.ap-video[data-autoplay="true"]').forEach(function(video){
      if(video.dataset.apObserved==='true'){return;}
      video.dataset.apObserved='true';
      if(reduce){video.autoplay=false;video.pause();video.controls=true;return;}
      video.muted=true;
      if(observer){observer.observe(video);}else{
        var play=video.play();if(play&&typeof play.catch==='function'){play.catch(function(){});}
      }
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){init(document);});}else{init(document);}
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();


if(!window.__astafisAnalyticsInit){window.__astafisAnalyticsInit=true;document.addEventListener('click',function(e){var a=e.target.closest('[data-astafis-event]');if(!a)return;window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'astafis_interaction',astafis_event:a.getAttribute('data-astafis-event'),link_url:a.getAttribute('href')||''});});}
